import { Form, FormSpy } from 'react-final-form'
import arrayMutators from 'final-form-arrays'
import { FormattedMessage } from 'react-intl'
import { FieldArray } from 'react-final-form-arrays'
import LaGuestInclusions from './LaGuestInclusions'
import InclusionsSection from './InclusionsSection'
import InsuranceSection from './InsuranceSection'
import { useDispatch } from 'react-redux'
import { showLoader } from '../../actions/main-actions'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import { useEffect } from 'react'
import { parseQuery } from '../../utils'

const GUEST_FIELDS = ['diversArray', 'nonDiversArray']
const ITEMS_FIELDS = ['rentalEquipment', 'courses', 'extras']

export default function inclusionsForm({
  initialValues,
  setInclusionsPrice,
  freeCancellationDays,
  saveSelectedInclusions,
  footer,
  showHint,
  saveAllInclusions,
}) {
  const dispatch = useDispatch()
  const saveInclusions = (values) => {
    dispatch(showLoader(true))
    const inclusions = values.roomPricingIds ? [...values.roomPricingIds] : []
    const insurances = []
    const inclusionsForGTM = []
    GUEST_FIELDS?.forEach((field) => {
      values[field]?.forEach((guestType, index) => {
        ITEMS_FIELDS?.forEach((fieldName) => {
          if(guestType[fieldName]) {
            guestType[fieldName].forEach((item) => {
              if(item.quantity || saveAllInclusions) {
                let inclusion = {
                  guestType: field === 'diversArray' ? 10 : 20,
                  diverNumber: index + 1,
                  pricing: item.pricingId,
                  quantity: item.quantity,
                  title: item.title,
                  isCourse: item.isCourse,
                  isIncluded: item.isIncluded,
                  isMandatory: item.isMandatory,
                  price: item.price,
                  amount: item.price * item.quantity,
                  payedInAdvance: item.payedInAdvance,
                  currency: item.currency,
                  extraValue: item.extraValue,
                  source: item.source,
                  pk: item.pk,
                  pks: item.pks,
                  initialQuantity: item.initialQuantity,
                  priceByQuantity: item.priceByQuantity,
                  bookedItems: item.bookedItems,
                }
                if(item.isCourse) {
                  inclusion.price = item.priceGross
                  inclusion.amount = item.priceGross * item.quantity
                  inclusion.diveProductId = item.id
                  inclusion.isDiverApplicable = item.isDiverApplicable
                  inclusion.isNondiverApplicable = item.isNondiverApplicable
                  inclusion.isStudentApplicable = item.isStudentApplicable
                } else {
                  item.payedPer = +item.payedPer
                }

                inclusions.push(inclusion)
                inclusionsForGTM.push(item)
              }
            })
          }
        })
      })
    })

    if(values.shopInclusions) {
      values.shopInclusions.forEach((items) => {
        items.forEach((item) => {
          if(item.quantity || saveAllInclusions) {
            inclusions.push({
              pricing: item.pricingId,
              quantity: item.quantity,
              isMandatory: item.isMandatory,
              isIncluded: item.isIncluded,
              title: item.title,
              price: item.price,
              currency: item.currency,
              extraValue: item.extraValue,
              payedInAdvance: item.payedInAdvance,
              payedPer: +item.payedPer,
              isDiveCenterExtra: item.isDiveCenterInclusion,
              amount: item.price * item.quantity,
              source: item.source,
              pk: item.pk,
              pks: item.pks,
              initialQuantity: item.initialQuantity,
              priceByQuantity: item.priceByQuantity,
              bookedItems: item.bookedItems,
            })
            inclusionsForGTM.push(item)
          }
        })
      })
    }
    if(values.insurances) {
      values.insurances.forEach((item) => {
        if(item.quantity || saveAllInclusions) {
          const insurance = {
            pricing: item.pricingId,
            quantity: item.quantity,
            isIncluded: true,
            title: item.title,
            price: item.price,
            source: item.source,
            currency: item.currency,
            isInsurance: true,
          }
          insurances.push(insurance)
          inclusions.push(insurance)
          inclusionsForGTM.push(item)
        }
      })
    }
    saveSelectedInclusions(
      inclusions,
      {
        insurances,
      },
      inclusionsForGTM,
    )
  }

  const setFormValues = (values) => {
    let inclusionsPrice = 0
    GUEST_FIELDS?.forEach((field) => {
      values[field]?.forEach((guestType) => {
        ITEMS_FIELDS?.forEach((fieldName) => {
          if(guestType[fieldName]) {
            guestType[fieldName].forEach((item) => {
              if(
                item.quantity &&
                (item.payedInAdvance || item.isCourse) &&
                !item.isMandatory &&
                !item.isIncluded
              ) {
                inclusionsPrice += parseFloat(item.priceGross) * item.quantity
              }
            })
          }
        })
      })
    })
    if(values.shopInclusions) {
      values.shopInclusions.forEach((inclusions) => {
        inclusions.forEach((item) => {
          if(
            item.quantity &&
            item.payedInAdvance &&
            !item.isMandatory &&
            !item.isIncluded
          ) {
            inclusionsPrice += parseFloat(item.priceGross) * item.quantity
          }
        })
      })
    }
    if(typeof setInclusionsPrice === 'function') {
      setInclusionsPrice(inclusionsPrice)
    }
  }

  useEffect(() => {
    const params = parseQuery()
    if(!isEmpty(initialValues) && params.savedOrder) {
      setTimeout(() => {
        document.getElementById('submit-btn').click()
      }, 300)
    }
  }, [initialValues])

  return (
    <Form
      onSubmit={saveInclusions}
      mutators={{
        ...arrayMutators,
      }}
      subscription={{
        value: true,
      }}
      initialValues={initialValues}
      render={({ handleSubmit, form, values }) => {
        // This info required for display correct guest name on my booking section.
        const diversArrayLength = get(
          form.getFieldState('diversArray'),
          'value.length',
          0,
        )
        return (
          <form onSubmit={handleSubmit} id='inclusions-forms'>
            <FormSpy onChange={(val) => setFormValues(val.values)} />
            {showHint && (
              <div className='hint-wrapper'>
                <FormattedMessage
                  id='checkout.hint'
                  defaultMessage='You can customize your package now or any time until 2 weeks prior to trip start'
                  tagName='p'
                />
                <button className='btn-red-invert'>
                  <FormattedMessage
                    id='skip_step'
                    defaultMessage='Skip this step'
                  />
                </button>
              </div>
            )}
            <section className='inclusions-section'>
              <h3 className='section-title'>
                <i className='icon font-icons dive-center-icon' />
                <FormattedMessage
                  id='customize_dive_package'
                  defaultMessage='Customize your dive package'
                />
              </h3>
              <FieldArray name='diversArray'>
                {({ fields }) => (
                  <LaGuestInclusions fields={fields} guestType='diver' />
                )}
              </FieldArray>
              <FieldArray name='nonDiversArray'>
                {({ fields }) => (
                  <LaGuestInclusions
                    fields={fields}
                    guestType='nonDiver'
                    totalGuests={diversArrayLength}
                  />
                )}
              </FieldArray>
            </section>

            <FieldArray name='shopInclusions'>
              {({ fields }) => <InclusionsSection fields={fields} />}
            </FieldArray>
            {window?.shop?.includeFreeDiveInsurance &&
              (<FieldArray name='insurances'>
                {({ fields }) => <InsuranceSection fields={fields} />}
              </FieldArray>)
            }

            {footer || (
              <div className='btn-wrap'>
                <div className='benefits'>
                  {freeCancellationDays && (
                    <p className='benefit'>
                      <FormattedMessage
                        id='48h_free_cancellation'
                        defaultMessage='48h free cancellation period'
                      />
                    </p>
                  )}
                </div>
                <button className='btn-red' id='submit-btn'>
                  <FormattedMessage defaultMessage='CONTINUE TO STEP 4' />
                </button>
                <p className='note'>
                  <FormattedMessage
                    id='dont_worry'
                    defaultMessage='Don`t worry - you won`t be charged yet'
                  />
                </p>
              </div>
            )}
          </form>
        )
      }}
    />
  )
}
